import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux'
import loggedOnUserProfile from './loggedOnUserProfile';
import serverAppConfig from './ServerAppConfig';
import appConfig from './appConfig';
import vendors from './vendors';
import vendorsDict from './vendorsDict';
import vendorUsers from './vendorUsers';
import vendorUsersDict from './vendorUsersDict';
import vendorInvitationsReportDict from './vendorInvitationsReportDict';

export const store = configureStore({
  reducer: {
    loggedOnUserProfile: loggedOnUserProfile,
    appConfig: appConfig,
    serverAppConfig: serverAppConfig,
    vendors: vendors,
    vendorsDict: vendorsDict,
    vendorInvitationsReportDict: vendorInvitationsReportDict,
    vendorUsers: vendorUsers,
    vendorUsersDict: vendorUsersDict
  },
})

type RootState = ReturnType<typeof store.getState>
type AppDispatch = typeof store.dispatch

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()